<template>
  <div
    ref="marquee"
    class="marquee"
  >
    <div
      ref="content"
      class="content"
      :style="{ transform: `translate3d(${translateX}px, 0, 0)` }"
    >
      <p
        v-for="item in number"
        :key="item"
        :style="{ marginLeft: `${item === 2 ? spaceWidth : 0}px` }"
      >
        <slot />
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IS_SSR } from '@/utils/env';

export default defineComponent({
  props: {
    animate: {
      type: Boolean,
      default: true,
    },
    spaceWidth: {
      type: Number,
      default: 20,
    },
    speed: {
      type: Number,
      default: 1,
    },
    delay: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      init: false,
      translateX: 0,
      timer: -999,
      delayTimer: -999,
      contentWidth: 0,
    };
  },
  computed: {
    number() {
      return this.init ? 2 : 1;
    },
  },
  watch: {
    animate(val) {
      // SSR阶段不执行动画
      if (IS_SSR) return;
      if (val) {
        if (!this.init) {
          this.$nextTick(this.readyAnimation);
        } else {
          this.startAnimation();
        }
      } else {
        if (this.init) this.stopAnimation();
      }
    },
  },
  mounted() {
    if (this.animate) this.$nextTick(this.readyAnimation);
  },
  beforeUnmount() {
    clearTimeout(this.delayTimer);
    clearInterval(this.timer);
  },
  methods: {
    getWidth() {
      const { offsetWidth: marqueeWidth } = this.$refs.marquee as HTMLElement;
      const { offsetWidth: contentWidth } = this.$refs.content as HTMLElement;
      return {
        contentWidth,
        marqueeWidth,
      };
    },
    readyAnimation() {
      const { contentWidth, marqueeWidth } = this.getWidth();
      this.contentWidth = contentWidth;
      if (marqueeWidth < contentWidth) {
        this.init = true;
        this.$nextTick(this.startAnimation);
      }
    },
    startAnimation() {
      clearTimeout(this.delayTimer);
      this.delayTimer = window.setTimeout(() => {
        clearInterval(this.timer);
        this.timer = window.setInterval(this.calcTranslateX, 30);
      }, this.delay);
    },
    calcTranslateX() {
      this.translateX -= this.speed;
      if (-this.translateX >= this.contentWidth + this.spaceWidth) {
        this.translateX = 0;
      }
    },
    stopAnimation() {
      clearTimeout(this.delayTimer);
      clearInterval(this.timer);
      setTimeout(() => {
        this.translateX = 0;
      }, 100);
    },
  },
});
</script>

<style lang="scss" scoped>
.marquee {
  white-space: nowrap;
  overflow: hidden;
  .content {
    display: inline-block;
    p {
      display: inline-block;
    }
  }
}
</style>
